import React from 'react'
import UserCard from './components/user_card'

const AttachedUserList = ({
  planId,
  attachedUserIds = [],
  loading,
  product,
  onDetachSuccess,
  onCancelSuccess
}) => {
  const getAttachUserList = () => {
    if (loading) {
      return (
        <div className="product-other-users-empty">
          Loading users...
        </div>
      )
    }
    if (!attachedUserIds.length) {
      return (
        <div className="product-attached-users-empty">
          No attached users
        </div>
      )
    }
    return attachedUserIds.map(userId => (
      <UserCard
        key={userId}
        userId={userId}
        planId={planId}
        product={product}
        onDetachSuccess={onDetachSuccess}
        attachedUserIds={attachedUserIds}
        onCancelSuccess={onCancelSuccess}
      />
    ))
  }

  return (
    <div className="product-attached-users-container">

      <div className="product-attached-users-header">
        <div className="product-users-title">
          Attached Users
        </div>
        <div className="product-users-description">
          Users attached to this plan subscription
        </div>
      </div>
      <div className="product-attached-users-body">
        {getAttachUserList()}
      </div>

    </div>
  )
}

export default AttachedUserList